'use client';

import { MdEmail, MdFacebook } from 'react-icons/md';

import { useTranslations } from 'next-intl';

import { Link } from '../../i18n/navigation';
import BrandLogo from '../BrandLogo';
import DiscordIcon from '../DiscordIcon';
import StoreBadges from '../StoreBadges';

function Footer() {
  const t = useTranslations();

  const legalLinks = [
    {
      href: '/privacy-policy',
      label: t('footer.links.privacy-policy')
    },
    {
      href: '/terms-of-use',
      label: t('footer.links.terms-of-use')
    },
    {
      href: '/data-attribution',
      label: t('footer.links.data-attribution')
    }
  ];

  return (
    <footer className="mt-8 w-full border-t border-white/10 bg-black text-white">
      <div className="mx-auto flex w-full max-w-7xl flex-col px-4 py-8 md:px-10 lg:py-10">
        <div className="grid gap-8 md:grid-cols-[1.2fr_1fr_1fr] lg:grid-cols-[1.4fr_1fr_1fr_1fr]">
          <div className="max-w-sm">
            <Link
              href="/"
              className="inline-flex min-h-[44px] items-center"
              aria-label="Trakio home"
            >
              <BrandLogo className="h-[24px] w-[156px]" />
            </Link>
            <p className="mt-3 text-sm leading-6 text-gray-100">
              {t('footer.description')}
            </p>
            <StoreBadges size="sm" orientation="horizontal" className="mt-4" />
          </div>

          <div>
            <h2 className="text-sm font-bold uppercase text-white">
              {t('footer.groups.product')}
            </h2>
            <ul className="mt-3 grid gap-2 text-sm text-gray-100">
              <li>
                <a
                  href="/br/noticias"
                  className="inline-flex min-h-[32px] items-center hover:text-white"
                >
                  Trakio Notícias
                </a>
              </li>
              <li>
                <Link
                  href="/"
                  className="inline-flex min-h-[32px] items-center hover:text-white"
                >
                  {t('header.links.home')}
                </Link>
              </li>
              <li>
                <a
                  href="https://trello.com/b/uHxAkj4m"
                  target="_blank"
                  className="inline-flex min-h-[32px] items-center hover:text-white"
                  rel="noreferrer"
                >
                  {t('footer.links.roadmap')}
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h2 className="text-sm font-bold uppercase text-white">
              {t('footer.groups.legal')}
            </h2>
            <ul className="mt-3 grid gap-2 text-sm text-gray-100">
              {legalLinks.map(link => (
                <li key={link.href}>
                  <Link
                    href={link.href}
                    className="inline-flex min-h-[32px] items-center hover:text-white"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h2 className="text-sm font-bold uppercase text-white">
              {t('footer.groups.support')}
            </h2>
            <a
              href="mailto:support@trakio.app"
              className="mt-3 inline-flex min-h-[44px] items-center gap-2 rounded-md border border-white/10 px-3 text-sm font-semibold text-white transition hover:border-red-600 hover:text-red-600"
            >
              <MdEmail size={18} />
              support@trakio.app
            </a>

            <div className="mt-4 flex items-center gap-3">
              <a
                href="https://www.facebook.com/TrakioApp"
                target="_blank"
                className="flex h-11 w-11 items-center justify-center rounded-md border border-white/10 text-white transition hover:border-red-600 hover:text-red-600"
                rel="noreferrer"
                aria-label="Trakio Facebook Page"
              >
                <MdFacebook size={22} />
              </a>
              <a
                href="https://discord.gg/Q8Dtjey9WC"
                target="_blank"
                className="flex h-11 w-11 items-center justify-center rounded-md border border-white/10 text-white transition hover:border-red-600 hover:text-red-600"
                rel="noreferrer"
                aria-label="Trakio Discord"
              >
                <DiscordIcon className="text-current" width={20} height={20} />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-8 flex flex-col gap-3 border-t border-white/10 pt-5 text-sm text-gray-100 md:flex-row md:items-center md:justify-between">
          <span>
            © 2026{' '}
            <Link href="/" className="font-bold text-white hover:text-red-600">
              Trakio
            </Link>
          </span>
          <span>{t('footer.copyright_note')}</span>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
